jQuery(document).ready(function ($) {
    $('#component-docs').find('h1').each(function () {
        var $item = $(this);
        $item.attr('id', $item.text().replace(/ /g, ''));
        var $id = $(this).attr('id');
        var a = '<li><a href="#' + $id + '">' + $item.text() + '</a></li>';
        $('#component-docs ul.toc').append(a);
    });

    $('.doc-div h1').each(function () {
        var $this = $(this).parent();
        $(this).click(function () {
            $this.find('.collapse').slideToggle();
        });
    });
});
